import React from 'react';
import 'react-responsive-modal/styles.css';
import { Modal } from 'react-responsive-modal';
import '../../css/Shared/RespModal.css';

  function RespModal(props) {
    return (
        <Modal open={props.hasOpen} closeOnOverlayClick={false} closeIcon=' ' center>
        <div {...props} style={{textAlign:'center', width:'auto', height:'auto'}}>
            {props.children}
        </div>
    </Modal>
    );
  }
  export default RespModal;